import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    tasks: [],
  },
  mutations: {
    createTask(state, task) {
      state.tasks.push({
        id: Date.now(),
        title: task.title,
        completed: false,
        editing: false
      });
      // state.tasks.push(newTask);
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
    deleteTask(state, task) {
      state.tasks = state.tasks.filter((t) => t.id !== task.id);
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
    saveTask(state, task) {
      task.editing = false;
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
    editTask(state, task) {
      task.editing = true;
      localStorage.setItem("tasks", JSON.stringify(state.tasks));
    },
    setTasks(state, tasks) {
      state.tasks = tasks;
    },
  },
  actions: {
    loadTasks({commit}) {
      try {
        const tasks = JSON.parse(localStorage.getItem("tasks")) || [];
        commit("setTasks", tasks);
      } catch (error) {
        console.error(error);
      }
    },
  },
});

store.dispatch("loadTasks");

export default store;